import React, { useCallback } from 'react';
import { MainTemplateList, TemplateHeading, TemplateList } from '../styles';
import TemplateCard from './templateCard';
import { rootStore } from '../../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ProjectTemplateModel } from '../../../../../../mobx/models/projectTemplate';
import { useMobileDevice } from '../../../../../../global/useMobile';
interface Props {
  onClickTemplate: () => void;
}
const TemplateListItem: React.FC<Props> = (props) => {
  const { onClickTemplate } = props;
  //Mobx store variables
  const { projectTemplateStore, projectStore } = rootStore;
  const { createProjectInput } = projectStore;
  const { projectTemplates, recommendedTemplates } = projectTemplateStore;
  //Other variables
  const isMobile = useMobileDevice();

  const handleSelectTemplate = useCallback(
    (template: ProjectTemplateModel) => {
      if (!template?.id) {
        console.warn('Template is missing required id');
        return;
      }

      const { createProjectInput } = projectStore;

      // Set template ID and selected template
      createProjectInput.setTemplateId(template.id);
      createProjectInput.setSelectedTemplate(template);

      // Set icon if available
      if (template.icon) {
        createProjectInput.setIcon(template.icon);
      }

      // Add project users if available
      if (template.userIds && template.userIds.length > 0) {
        template.userIds.forEach((userId) => {
          if (userId && !createProjectInput.hasProjectUser(userId)) {
            createProjectInput.addProjectUser(userId);
          }
        });
      } else {
        createProjectInput.clearProjectUser();
      }
      if (isMobile) onClickTemplate();
    },
    [isMobile, onClickTemplate, projectStore]
  );

  return (
    <>
      {projectTemplates && projectTemplates?.length > 0 && (
        <MainTemplateList>
          <TemplateHeading>Your Templates</TemplateHeading>
          <TemplateList>
            {projectTemplates.map((template) => {
              return (
                <TemplateCard
                  templateDetails={template}
                  isActive={createProjectInput?.templateId === template.id}
                  onClick={() => handleSelectTemplate(template)}
                />
              );
            })}
          </TemplateList>
        </MainTemplateList>
      )}
      {recommendedTemplates && recommendedTemplates?.length > 0 && (
        <MainTemplateList>
          <TemplateHeading>Recommended</TemplateHeading>
          <TemplateList>
            {recommendedTemplates.map((template) => {
              return (
                <TemplateCard
                  templateDetails={template}
                  isActive={createProjectInput?.templateId === template.id}
                  onClick={() => handleSelectTemplate(template)}
                />
              );
            })}
          </TemplateList>
        </MainTemplateList>
      )}
    </>
  );
};

export default observer(TemplateListItem);
